import { Text } from '~/commonComponents';
import { useMediaQuery } from '~/hooks';
import { Colors } from '~/themes/colors';

export const TableHeader = () => {
  const [isSmallScreen] = useMediaQuery(['lg']);

  return (
    <thead style={{ borderBottom: `2px solid ${Colors.neutral_divider}` }}>
      <tr>
        <th style={{ width: 76 }} />
        <th style={{ textAlign: 'left' }}>
          <Text bold color={Colors.primary_500} fontSize={18} textAlign="left">
            Professional
          </Text>
        </th>
        {!isSmallScreen && (
          <th style={{ textAlign: 'left' }}>
            <Text bold color={Colors.primary_500} fontSize={18} textAlign="left">
              Office
            </Text>
          </th>
        )}
        <th style={{ textAlign: 'left' }}>
          <Text bold color={Colors.primary_500} fontSize={18} textAlign="left">
            Details
          </Text>
        </th>
        <th style={{ textAlign: 'left' }}>
          <Text bold color={Colors.primary_500} fontSize={18} textAlign="left">
            Review Hours
          </Text>
        </th>
        <th />
      </tr>
    </thead>
  );
};
